import React from "react";
import "./sidebar.scss";
import { NavLink } from "react-router-dom";
const Sidebar = ({setOpen}) => {
  const data = [
    {
      path: "/",
      name: "home",
    },
    {
      path: "/about",
      name: "about",
    },
    {
      path: "/portfolio",
      name: "portfolio",
    },
    {
      path: "/news",
      name: " news",
    },
    {
      path: "/contact",
      name: "contact",
    },
  ];

  return (
    <div className="sidebar-wrapper">
      <div className="container">
        <div className="logo">
          <h2>Calgone</h2>
        </div>
        <ul>
          {data.map((item, index) => (
            <Link link={item.path} setOpen={setOpen} name={item.name} key={index} />
          ))}
        </ul>
        <div className="footer">
          <p>© 2023 CalgoneCreated by Calgone</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;

function Link({ link, name ,setOpen}) {
  return (
    <li className="nav-link">
      <NavLink
        to={link}
        onClick={()=>setOpen(false)}
        className={({ isActive, isPending }) => (isActive ? "active" : "")}
      >
        {name}
      </NavLink>
    </li>
  );
}
